import { ICommand, IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Hold } from '../builders/holds_builder';
import { HoldsService } from '../services/holds_service';

angular
  .module('capability-ng-holds')
  .factory(
    'loadHoldsListCommand',
    function loadHoldsListCommandDefinition(
      defineCommand: IDefineCommand,
      loadHoldsCommand: ICommand,
      holdsService: HoldsService
    ) {
      return defineCommand('loadHoldsListCommand', function loadHoldsListCommand(deferred: any) {
        const loadHolds = () =>
          loadHoldsCommand().then((data: any) => {
            deferred.resolve(data);
          });
        holdsService
          .init()
          .then(() => {
            loadHolds();
          })
          .catch(() => {
            loadHolds();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/commands/load_holds_list_command.ts